enum NavigatioStateType {
    SCHEDULE = 'schedule',
    USER_SCHEDULE = 'user_schedule',
    USER_RECURRENCE = 'user_recurrence',
    SCHEDULE_RECURRENCE = 'schedule_recurrence'
 }

export { NavigatioStateType }